export default __webpack_public_path__ + "static/media/learnops-community.198db167.svg";